import React, { useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useDispatch, useSelector } from "react-redux";
import { ModalV2 } from "components/Modal/ModalV2";
import { uploadEvidence } from "redux/actions/retentionOutputs/retentionOutputsActions";

const ACCEPTED_TYPES = ["application/pdf", "image/jpeg", "image/png"];
const ACCEPTED_EXT = ".pdf,.jpg,.jpeg,.png";
const MAX_SIZE_MB = 10;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

export const EvidenceUploadModal = ({ open, onClose, row }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [dragOver, setDragOver] = useState(false);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const loading = isLoadingComp?.uploadingEvidence || false;

  const reset = () => {
    setFile(null);
    setError("");
    setDragOver(false);
  };

  const handleClose = () => {
    if (loading) return;
    reset();
    onClose();
  };

  const validateFile = (f) => {
    if (!f) return false;
    if (!ACCEPTED_TYPES.includes(f.type)) {
      setError("Formato no válido. Solo se permiten PDF, JPG o PNG.");
      return false;
    }
    if (f.size > MAX_SIZE_BYTES) {
      setError(`El archivo excede el límite de ${MAX_SIZE_MB}MB.`);
      return false;
    }
    setError("");
    return true;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (loading) return;
    const f = e.dataTransfer.files[0];
    if (validateFile(f)) setFile(f);
  };

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (validateFile(f)) setFile(f);
  };

  const handleSubmit = () => {
    if (!file || !row?.id) return;
    dispatch(uploadEvidence(row.id, file, () => {
      reset();
      onClose();
    }));
  };

  return (
    <ModalV2
      open={open}
      onClose={handleClose}
      title="Adjuntar Evidencia"
      onSubmit={handleSubmit}
      loading={loading}
      submitBtnText="Subir"
      confirmColor="info"
      disabledBtn={!file || loading}
      justConfirm
    >
      <Grid item xs={12}>
        <Box
          onDragOver={(e) => { e.preventDefault(); if (!loading) setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          sx={{
            border: "2px dashed",
            borderColor: dragOver ? "primary.main" : "grey.400",
            borderRadius: 2,
            p: 4,
            textAlign: "center",
            cursor: loading ? "not-allowed" : "pointer",
            bgcolor: dragOver ? "action.hover" : "background.paper",
            transition: "all 0.2s",
            maxWidth: "100%",
            overflow: "hidden",
          }}
          onClick={() => {
            if (!loading) document.getElementById("evidence-file-input").click();
          }}
        >
          <CloudUploadIcon sx={{ fontSize: 48, color: "grey.500", mb: 1 }} />
          <Typography variant="body2" color="textSecondary" noWrap>
            {file ? file.name : "Arrastra un archivo aquí o haz clic para seleccionar"}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Formatos: PDF, JPG, PNG (máx. {MAX_SIZE_MB}MB)
          </Typography>
          <input
            id="evidence-file-input"
            type="file"
            accept={ACCEPTED_EXT}
            hidden
            onChange={handleFileChange}
          />
        </Box>
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Grid>
    </ModalV2>
  );
};
